<template>
    <div class="white-rounded-box mb-7">
        <div class="mx-7 mt-6">
            <div class="flex justify-between">
                <h2 class="text-lg md:text-xl mb-2">{{ header }}</h2>
            </div>
        </div>
        <div v-if="show_search_box">
            <div class="ml-10 mt-6 rounded-lg">
                <form @submit.prevent="fetchOrgs" class="flex items-center">
                    <div class="relative w-full">
                        <div
                            class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                        >
                            <svg
                                aria-hidden="true"
                                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                        <input
                            type="text"
                            v-model="search_text"
                            class="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                            placeholder="Search for an Organization"
                            required
                        />
                    </div>
                    <button
                        v-if="!isLoading"
                        type="submit"
            :disabled="disabled"
            class="p-2.5 mr-2 text-sm font-medium text-salesium-blue bg-white"
            >
            <svg
                class="w-7 h-7"
                fill="none"
                :stroke="disabled ? '#777' : 'currentColor'"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                ></path>
            </svg>
            <span class="sr-only">Search</span>
            </button>
            <span
                v-else
                class="p-2.5 mr-2 text-xs font-medium text-salesium-blue bg-white"
            >
                        <svg
                            class="animate-spin w-7 h-7"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-width="4"
                                stroke-dasharray="30 15"
                            ></circle>
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </span>
            </form>
        </div>
            <div
                v-if="!isLoading && showOrgTable"
                class="w-full mt-2 max-h-96 overflow-y-scroll z-50"
            >
                <table class="w-full leading-normal bg-gray-200 rounded-xl">
                    <thead>
                    <tr>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider rounded-t-xl"
                        >
                            Organization
                        </th>
                        <th class="flex w-full my-8 justify-end"
                        >
                            <button v-if="(show_status !== 'dashboard') && !showCreateButton"
                                type="button"
                                @click="createNewOrg"
                                class="flex text-white storefront-btn-blue font-medium rounded-lg text-sm mr-14 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                            >
                                Create
                            </button>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                      <template v-for="(org, i) in returnOrgs">
                        <tr class="hover:bg-gray-400 bg-white">
                            <td
                                class="px-5 py-5 border-b border-gray-200 text-sm" colspan="2"
                            >
                                <div class="flex items-center">
                                    <div class="ml-3">
                                        <p class="text-gray-900 whitespace-no-wrap">
                                            <a v-if="org.status === 1"
                                                :href="'/organizations/' + org.domain"
                                            >
                                                {{ org.dba ? org.dba : org.name }}
                                            </a>
                                            <span v-else-if="show_status === 'dashboard' && org.status === 0">
                                                {{ org.dba ? org.dba : org.name }} (Pending Salesium approval)
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                      </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div
            class="flex bg-white w-full my-8 justify-between items-center ml-3"
            v-if="noResults"
        >
            No result found for this search.

            <button v-if="showCreatButton"
                type="button"
                @click="createNewOrg"
                class="flex text-white storefront-btn-blue font-medium rounded-lg text-sm mr-14 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
                Create
            </button>
        </div>
        <div class="ml-1 xl:ml-10">
            <div class="lg:text-lg md:text-md text-hint flex items-center">
                <OrgList :user="user" :show_status="show_status" :organizations="organizations"/>
            </div>
        </div>
    </div>
</template>

<script>
import OrgList from './OrgList.vue';
export default {
    name: "MyOrganizations",
    props: ['user', 'organizations', 'show_status', 'header', 'show_search_box'],
    components: {
        OrgList,
    },
    data() {
      return {
          returnOrgs: [],
          isLoading: false,
          showCreateButton: false,
          showOrgTable: false,
          noResults: false,
          search_text: "",
      }
    },
    methods: {
        async fetchOrgs() {
            this.isLoading = true;
            this.showCreateButton = false;
            await axios
                .get(`/api/organizations?search=${this.search_text.trim()}`)
                .then((response) => {
                    this.isLoading = false;
                    this.returnOrgs = response.data.data;
                    console.log( response.data.data);
                    console.log( 'this.show_status: ' + this.show_status);
                    if( this.returnOrgs.length === 0) {
                        this.showCreateButton = this.show_status !== 'dashboard';
                        this.showOrgTable = false;
                        this.noResults = true;
                    } else if( this.returnOrgs.filter( function ( org){ return org.status === 1 }).length === 0) {
                        this.showCreateButton = this.show_status !== 'dashboard';
                        this.showOrgTable = false;
                        this.noResults = true;
                    } else {
                        this.showOrgTable = true;
                        this.noResults = false;
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.showCreateButton = true;
                    this.noResults = true;
                    this.errorMessage = "Search failed!";
                    this.showError = true;
                    console.log({ error });
                });
        },
        createNewOrg() {
            window.location.href = "/control-panel/Organization";
        },
    },
    computed: {
        disabled() {
            return this.search_text.trim().length === 0;
        },
    },
}
</script>

<style scoped>

</style>
